const checkIsTruncated = (ref) => {
  if (ref.current) {
    return ref.current.scrollWidth > ref.current.clientWidth;
  }
  return false;
};

export { checkIsTruncated as default };
//# sourceMappingURL=checkIsTruncated.es.js.map
